export const Breakpoints = {
  xs: 376,
  s: 480,
  m: 600,
  tb: 720,
  tb2: 768,
  l: 960,
  sxl: 1024,
  xl: 1280,
  xxl: 1440,
};
